module.exports = __webpack_public_path__ + "0483875e2e2064cd6df544e49db2196c.png";